import React, { useState } from 'react';

const VerticalIconBar = ({ onIconClick, activeView, isVisible = true }) => {
	const [
		hoveredIcon,
		setHoveredIcon
	] = useState(null);

	const icons = [
		{
			id: 'roster',
			icon: 'fas fa-clipboard-list',
			label: 'My Roster',
			description: 'View your roster'
		},
		{
			id: 'league-rosters',
			icon: 'fas fa-users',
			label: 'League Rosters',
			description: 'View league rosters'
		},
		{
			id: 'schedule',
			icon: 'fas fa-calendar-alt',
			label: 'Schedule',
			description: 'View matchups and schedule'
		}
	];

	const handleIconClick = (icon) => {
		onIconClick(icon.id);
	};

	// Don't render if not visible
	if (!isVisible) {
		return null;
	}

	return (
		<div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-50">
			<div className="flex flex-col space-y-4 bg-white dark:bg-dark-card shadow-lg rounded-l-lg p-3 border-l border-t border-b border-gray-200 dark:border-dark-border">
				{icons.map((icon) => (
					<div key={icon.id} className="relative group">
						<button
							onClick={() => handleIconClick(icon)}
							className={`
								w-12 h-12 flex items-center justify-center rounded-lg transition-all duration-200
								${activeView === icon.id
									? 'bg-blue-500 text-white shadow-md'
									: 'bg-gray-100 dark:bg-dark-bg text-gray-600 dark:text-dark-text-secondary hover:bg-blue-100 dark:hover:bg-dark-hover hover:text-blue-600 dark:hover:text-blue-400'}
								${activeView === icon.id ? 'scale-110 shadow-lg' : ''}
							`}
							onMouseEnter={() => setHoveredIcon(icon.id)}
							onMouseLeave={() => setHoveredIcon(null)}
						>
							<i className={`${icon.icon} text-lg`} />
						</button>

						{/* Tooltip */}
						<div
							className={`
							absolute right-16 top-1/2 transform -translate-y-1/2 
							bg-gray-900 text-white text-sm px-3 py-2 rounded-lg shadow-lg
							opacity-0 group-hover:opacity-100 transition-opacity duration-200
							pointer-events-none whitespace-nowrap z-50
						`}
						>
							<div className="font-medium">{icon.label}</div>
							<div className="text-xs text-gray-300">{icon.description}</div>
							{/* Arrow pointing to the icon */}
							<div className="absolute left-full top-1/2 transform -translate-y-1/2">
								<div className="w-0 h-0 border-l-8 border-l-gray-900 border-t-4 border-t-transparent border-b-4 border-b-transparent" />
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default VerticalIconBar;
